/** Where a space opens one of its micro-apps: the viewer, kept under the space. */
export const spaceAppPath = (spaceUuid: string, appUuid: string) => `/spaces/${spaceUuid}/apps/${appUuid}`;
